// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
.analysis-container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
    color: #333;
  }
  
  /* Header styles */
  .analysis-header {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
  }
  
  .back-button {
    background: none;
    border: none;
    color: #1a73e8;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 8px 15px;
    border-radius: 4px;
    transition: background 0.2s;
  }
  
  .back-button:hover {
    background: #f1f8ff;
  }
  
  .header-middle {
    flex-grow: 1;
    text-align: center;
    color: #5f6368;
    font-weight: 500;
  }
  
  .header-title {
    font-size: 24px;
    font-weight: 600;
    color: #202124;
    margin: 0;
  }
  
  /* Detailed Analysis Section */
  .detailed-analysis {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    padding: 20px;
    margin-bottom: 25px;
  }
  
  .location-info h2 {
    font-size: 22px;
    margin: 0 0 5px;
    color: #202124;
    justify-content: center;
  }
  
  .location-info p {
    justify-content: center;
    color: #5f6368;
    margin: 0;
  }
  
  .scores-container {
    display: flex;
    justify-content: center;
    margin: 25px 0;
  }
  
  .score-item {
    text-align: center;
  }
  
  .score-value {
    font-size: 60px;
    font-weight: 900;
    color: #1a73e8;
  }
  
  .score-label {
    color: #5f6368;
    font-size: 16px;
  }
  
  .stats-container {
    display: flex;
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
  
  .stat-item {
    text-align: center;
    flex: 1 1;
  }
  
  .stat-value {
    font-size: 28px;
    font-weight: 700;
    color: #1a73e8;
  }
  
  .stat-label {
    color: #5f6368;
    font-size: 14px;
  }
  
  /* Section Titles */
  .section-title {
    font-size: 20px;
    font-weight: 600;
    color: #202124;
    margin: 0 0 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #f1f3f4;
  }
  
  /* Market Insights */
  .market-insights {
    margin-bottom: 25px;
  }
  
  .premium-banner {
    background: linear-gradient(135deg, #4285f4, #34a853);
    border-radius: 10px;
    padding: 20px;
    color: white;
  }
  
  .premium-content h3 {
    font-size: 18px;
    margin: 0 0 8px;
  }
  
  .premium-content p {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
  }
  
  /* Compare Area */
  .compare-area {
    margin-bottom: 25px;
  }
  
  .compare-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    padding: 20px;
  }
  
  .input-group {
    margin-bottom: 15px;
  }
  
  .compare-input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #dadce0;
    border-radius: 8px;
    font-size: 16px;
    box-sizing: border-box;
  }
  
  .compare-input:focus {
    outline: none;
    border-color: #1a73e8;
    box-shadow: 0 0 0 2px rgba(26,115,232,0.2);
  }
  
  .compare-button {
    background: #1a73e8;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
    margin-bottom: 15px;
    transition: background 0.2s;
  }
  
  .compare-button:hover {
    background: #1669d9;
  }
  
  .compare-description {
    color: #5f6368;
    font-size: 14px;
    margin: 0;
    line-height: 1.5;
  }
  
  /* Comparison Results */
  .comparison-results {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    padding: 20px;
    margin-bottom: 25px;
  }
  
  .comparison-grid {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 20px;
    align-items: center;
    text-align: center;
  }
  
  .comparison-item {
    padding: 15px;
  }
  
  .comparison-item h3 {
    margin: 0 0 10px;
    font-size: 18px;
  }
  
  .comparison-score-for-area1 {
    font-size: 32px;
    font-weight: 700;
    color: #1a73e8;
    margin: 10px 0;
  }

  .comparison-score-for-area2 {
    font-size: 32px;
    font-weight: 700;
    color: #34a853;
    margin: 10px 0;
  }
  
  .close-comparison {
    display: block;
    margin: 20px auto 0;
    background: none;
    border: none;
    color: #5f6368;
    cursor: pointer;
  }
  
  /* Categories */
  .top-categories, .amenity-categories {
    margin-bottom: 25px;
  }
  
  .categories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 15px;
  }
  
  .category-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    padding: 20px 15px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid #eee;
  }
  
  .category-card.active {
    border-color: #1a73e8;
    box-shadow: 0 2px 10px rgba(26,115,232,0.15);
  }
  
  .category-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  .category-icon {
    font-size: 32px;
    margin-bottom: 12px;
  }
  
  .category-name {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 8px;
    color: #202124;
  }
  
  .category-count {
    color: #5f6368;
    font-size: 13px;
  }
  
  /* Coverage Statistics */
  .coverage-stats {
    margin-bottom: 25px;
  }
  
  .stats-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    padding: 20px;
  }
  
  .stats-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  
  .stats-grid .stat-item {
    text-align: center;
  }
  
  .stats-grid .stat-value {
    font-size: 28px;
  }
  
  /* Category Detail */
  .category-detail {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    padding: 20px;
    margin-bottom: 25px;
  }
  
  .category-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .category-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
  }
  
  .performance-rating {
    text-align: center;
  }
  
  .rating-value {
    font-size: 32px;
    font-weight: 700;
    color: #1a73e8;
  }
  
  .rating-label {
    color: #5f6368;
    font-size: 14px;
  }
  
  .rating-score {
    font-size: 16px;
    font-weight: 500;
    color: #5f6368;
  }
  
  .category-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    margin-bottom: 20px;
  }
  
  .stat-group {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
  }
  
  .stat-label {
    color: #5f6368;
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .stat-value {
    font-size: 20px;
    font-weight: 700;
    color: #202124;
  }
  
  .nearby-places {
    margin-bottom: 20px;
  }
  
  .nearby-places h3 {
    font-size: 18px;
    margin: 0 0 15px;
    color: #202124;
  }
  
  .place-item {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
  }
  
  .place-name {
    font-weight: 600;
    margin-bottom: 5px;
  }
  
  .place-rating {
    color: #34a853;
    font-weight: 500;
    margin-bottom: 5px;
  } 
  .map-link {
    display: inline-block;
    color: #1a73e8;
    text-decoration: none;
    font-size: 14px;
    margin-top: 5px;
  }
  
  .map-link:hover {
    text-decoration: underline;
  }
  
  .map-actions {
    text-align: center;
  }
  
  .view-map {
    display: inline-block;
    background: #1a73e8;
    color: white;
    padding: 10px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    transition: background 0.2s;
  }
  
  .view-map:hover {
    background: #1669d9;
  }
  
  /* Recommendations */
  .recommendations {
    margin-bottom: 40px;
  }
  
  .subsection-title {
    font-size: 18px;
    font-weight: 600;
    color: #202124;
    margin: 0 0 15px;
  }
  
  .recommendation-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
  }
  
  .recommendation-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    padding: 20px;
    transition: all 0.2s;
  }
  
  .recommendation-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .card-icon {
    font-size: 32px;
    margin-bottom: 15px;
  }
  
  .recommendation-card h4 {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 10px;
    color: #202124;
  }
  
  .recommendation-card p {
    color: #5f6368;
    margin: 0;
    line-height: 1.5;
  }
  
  /* Loading, Error, No Data States */
  .loading-container, 
  .error-container, 
  .no-data-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
    text-align: center;
  }
  
  .loading-spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #1a73e8;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  .error-icon, .no-data-icon {
    font-size: 48px;
    margin-bottom: 20px;
  }
  
  .error-container h3, .no-data-container h3 {
    font-size: 24px;
    margin: 0 0 10px;
  }
  
  .error-container p, .no-data-container p {
    color: #5f6368;
    margin: 0 0 20px;
    max-width: 500px;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .scores-container {
      flex-direction: column;
      gap: 20px;
    }
    
    .stats-container {
      flex-direction: column;
      gap: 15px;
    }
    
    .comparison-grid {
      grid-template-columns: 1fr;
      gap: 30px;
    }
    
    .recommendation-cards {
      grid-template-columns: 1fr;
    }
    
    .header-title {
      font-size: 20px;
    }
    
    .category-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
    }
  }
  
  @media (max-width: 480px) {
    .analysis-header {
      flex-direction: column;
      text-align: center;
      gap: 10px;
    }
    
    .back-button {
      align-self: flex-start;
    }
    
    .header-middle {
      display: none;
    }
  }


  /* Comparison Results */
.attribute-comparison {
  margin-top: 30px;
}

.attribute-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.attribute-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.attribute-name {
  font-weight: 500;
}

.attribute-scores {
  display: flex;
  gap: 8px;
}

.score1 {
  color: #1a73e8;
  font-weight: 600;
}

.score2 {
  color: #34a853;
  font-weight: 600;
}

.score-divider {
  color: #5f6368;
}





/* Add these new styles at the end of the file */

/* Performance Bar */
.performance-bar {
  width: 100%;
  height: 8px;
  background-color: #f1f1f1;
  border-radius: 4px;
  margin: 10px 0;
  overflow: hidden;
}

.performance-fill {
  height: 100%;
  transition: width 0.3s ease;
}

.performance-score {
  font-size: 14px;
  font-weight: 600;
  color: #5f6368;
  text-align: center;
}

/* View Locations Button */
.view-locations {
  background: #1a73e8;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;
  transition: background 0.2s;
}

.view-locations:hover {
  background: #1669d9;
}

/* Places Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* .places-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
} */

/* Modal Container */
.places-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  /* Remove overflow: hidden */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
}

.modal-header button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #5f6368;
}

/* .places-list {
  padding: 20px;
} */

/* Scrollable Content Area */
.places-list {
  padding: 20px;
  overflow-y: auto; /* Enable vertical scrolling */
  flex: 1 1; /* Take up available space */
}

/* Places List Container */
.places-scrollable {
  max-height: 300px;
  overflow-y: auto; /* Ensure scrolling for long lists */
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px;
}

/* Scrollbar Styling */
.places-scrollable::-webkit-scrollbar {
  width: 8px;
}

.places-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.places-scrollable::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.places-scrollable::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Score Bars in Comparison */
.score-bar {
  width: 100%;
  height: 20px;
  background-color: #f1f1f1;
  border-radius: 10px;
  margin: 5px 0;
  position: relative;
  overflow: hidden;
}

.score-bar-fill {
  height: 100%;
  border-radius: 10px;
}

.score-value {
  position: center;
  right: 8px;
  top: 30%;
  transform: translateY(-50%);
  font-size: 25px;
  font-weight: 600;
  color: black;
  /* text-shadow: 0 0 2px rgba(0,0,0,0.5); */
}

/* Map Icon */
.map-icon {
  margin-left: 5px;
}

/* Attribute Comparison */
.attribute-scores {
  width: 60%;
}

.attribute-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.attribute-name {
  font-weight: 500;
  width: 40%;
}



/* Add to the end of AnalysisPage.css */

/* Category Details Container */
.category-details-container {
  margin-top: 30px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-all-button {
  background: #f44336;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.close-all-button:hover {
  background: #d32f2f;
}

.category-detail {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  padding: 20px;
  margin-bottom: 25px;
  position: relative;
}

.close-detail {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #5f6368;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-detail:hover {
  background: #f1f1f1;
}
/* Inline Top‑3 styling — refined */
.top-3-inline {
  margin: 24px 0;
  padding-top: 16px;
  border-top: 1px solid var(--border-color, #e0e0e0);
  text-align: center;
}

.top-3-inline .subsection-title {
  font-size: 1rem;         /* match other subsection headings */
  font-weight: 500;
  color: var(--text-primary, #333);
  margin-bottom: 12px;
}

.top3-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;          /* horizontal + vertical gaps */
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: justify;
  justify-content: center;   /* center the group */

}

.top3-list li {
  display: flex;
  align-items: center;
  font-size: 0.9375rem;    /* 15px equivalent */
  color: var(--text-secondary, #555);
  text-align: center;
}

.top3-icon {
  font-size: 1.25rem;      /* 20px equivalent */
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.top3-score {
  font-weight: 600;
  margin: 0 4px;
  color: var(--accent, #1a73e8);
}

.top3-count {
  font-size: 0.8125rem;    /* 13px equivalent */
  color: var(--text-tertiary, #777);
  margin-left: 4px;
}



/* Add to the end of AnalysisPage.css */
.top-categories-comparison {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.top-categories-comparison h3 {
  font-size: 18px;
  color: #202124;
  margin-bottom: 15px;
}

/* Mobile: stack top‑categories‑comparison into one column */
/* @media (max-width: 768px) {
  .top-categories-comparison .comparison-categories-grid {
    grid-template-columns: 1fr !important;
    gap: 10px;
  }

  .top-categories-comparison .area-top-categories {
    padding: 10px;
  }
} */

/* — Always two columns, horizontally scrollable on small screens */
.top-categories-comparison .comparison-categories-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  overflow-x: auto;               /* allow sideways scroll */
  -webkit-overflow-scrolling: touch;
  padding-bottom: 1rem;           /* give a little breathing room */
}

/* optional: ensure each cell keeps a minimum width for readability */
.top-categories-comparison .comparison-categories-grid > * {
  min-width: 240px;
}

/* remove any leftover stacking rule */
@media (max-width: 768px) {
  /* nothing here — we want the same two‑column layout */
}


.comparison-categories-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.area-top-categories {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 15px;
}

.area-top-categories h4 {
  margin: 0 0 15px;
  font-size: 16px;
  font-weight: 600;
}

.category-comparison-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.category-comparison-item:last-child {
  border-bottom: none;
}

.category-icon {
  margin-right: 10px;
  font-size: 24px;
}

.category-name {
  flex-grow: 1;
  font-weight: 500;
}

.category-score {
  font-weight: 600;
  color: #1a73e8;
  font-size: 18px;
}



/* Top 3 inline with progress bars */
.top3-list {
  display: flex;
  flex-direction: column;     /* one per row; switch to row+wrap if you like */
  gap: 12px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.top3-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.top3-icon {
  font-size: 1.25rem;
}

.top3-label {
  flex: 0 0 120px;            /* reserve space for the label */
  font-weight: 500;
  color: #333;
}

.top3-bar {
  flex: 1 1;                    /* grows to fill remaining space */
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.top3-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease;
}

.top3-score {
  flex: 0 0 50px;             /* fixed width for the “8.5/10” */
  text-align: right;
  font-weight: 600;
  color: #1a73e8;
}

/* Animate the bar expanding from 0 → var(--fill) */
.top3-fill {
  width: 0;
  animation: fillBar 0.8s ease-out forwards;
}

@keyframes fillBar {
  to {
    width: var(--fill);
  }
}

/* Fade each item in and slide up slightly */
.top3-item {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeUp 0.6s ease-out forwards;
  /* stagger each by its index: set --i on the element */
  animation-delay: calc(var(--i) * 0.15s);
}

@keyframes fadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.top3-fill.low    { background: #e74c3c; }  /* <5 */
.top3-fill.medium { background: #f39c12; }  /* 5–7.9 */
.top3-fill.high   { background: #27ae60; }  /* ≥8 */

@keyframes fillBar {
  to { width: var(--fill); }
}

/* wrap the little bar + labels */
.category-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

/* let the mini‑bar grow to fill available width */
.category-stats .top3-bar {
  flex: 1 1;
  height: 6px;
}

/* reuse your existing .top3-fill animation & styling */
.category-stats .top3-fill {
  border-radius: 3px;
}

/* ensure the score text matches your Top‑3 style */
.top3-score {
  font-size: 0.9rem;
  font-weight: 600;
}

/* count text, same as Top‑3 count */
.top3-count {
  font-size: 0.9rem;
  color: #666;
}

/* 3‑column layout for category cards */
.amenity-categories.compare .categories-grid.compare {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 16px;
}

.category-card.compare {
  display: contents; /* children occupy the grid cells */
}

.category-name-col {
  grid-column: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-stats-col {
  grid-column: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Two‑column modal content */
.places-modal.compare .modal-content.compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

/* ✅ If only ONE street exists, make modal content full width (desktop) */
.places-modal.compare .modal-content.compare:has(.modal-column:only-child) {
  grid-template-columns: 1fr !important;
}

/* Also ensure the single column stretches fully */
.places-modal.compare .modal-content.compare .modal-column:only-child {
  width: 100%;
}

.modal-column h4 {
  margin-bottom: 8px;
}
/* Add to the end */
.amenity-categories.compare-mode {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.compare-column {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 15px;
}

.compare-column h3 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}




/* Add to end of file */
.places-modal.compare .modal-content.compare {
  display: flex;
  gap: 20px;
  padding: 15px;
}

.modal-column {
  flex: 1 1;
}

.modal-column h4 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.places-scrollable {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 8px;
}

.place-item {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.place-item:last-child {
  border-bottom: none;
}
















/* Comparison Card Styles */
.comparison-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid #eaeaea;
}

.comparison-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.category-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.category-icon {
  font-size: 28px;
  margin-right: 12px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 50%;
}

.category-name {
  font-size: 16px;
  font-weight: 600;
  color: #202124;
  margin: 0;
}

.comparison-stats {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.comparison-street {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.street-name {
  font-size: 14px;
  font-weight: 500;
  color: #5f6368;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.score-badge {
  display: flex;
  align-items: baseline;
}

.score {
  font-size: 18px;
  font-weight: 700;
  margin-right: 4px;
}

.comparison-street:nth-child(1) .score {
  color: #1a73e8;
}

.comparison-street:nth-child(2) .score {
  color: #34a853;
}

.count {
  font-size: 13px;
  color: #70757a;
}

.comparison-bars {
  height: 6px;
  background: #f1f3f4;
  border-radius: 3px;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
}

.bar {
  position: absolute;
  height: 100%;
  border-radius: 3px;
  top: 0;
  transition: width 0.5s ease;
}

.bar1 {
  background: #1a73e8;
  left: 0;
  z-index: 2;
}

.bar2 {
  background: #34a853;
  left: 0;
  z-index: 1;
  opacity: 0.8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .comparison-street {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .street-name {
    max-width: 100%;
  }
  
  .score-badge {
    align-self: flex-end;
  }
}

/* Modal improvements */
.places-modal.compare .modal-content.compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  padding: 20px;
}

.modal-column {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
}

.modal-column h4 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  color: #202124;
  font-size: 18px;
}

.places-scrollable {
  max-height: 350px;
  overflow-y: auto;
  padding-right: 10px;
}

/* Performance score in modal */
.modal-stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.stat-group {
  text-align: center;
  flex: 1 1;
}

.stat-label {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 20px;
  font-weight: 700;
}




/* ... existing styles ... */

/* Add to the end of the file */

/* Amenity Comparison Section */
.amenity-categories.compare-mode {
  margin-top: 30px;
}

.section-title.comparison-title {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 2px solid #1a73e8;
  padding-bottom: 10px;
}

/* Comparison Cards Grid */
.categories-grid.comparison {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  justify-content: center;
}

/* Comparison Card */
.category-card.comparison {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  transition: transform 0.3s ease;
  border: 1px solid #eaeaea;
}

.category-card.comparison:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.category-header.comparison {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.category-name.comparison {
  font-size: 20px;
  font-weight: 600;
  color: #202124;
  margin: 0;
}

/* Street Comparison Items */
.street-comparison {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 15px;
}

.street-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background 0.2s;
}

.street-row:hover {
  background: #f1f8ff;
}

.street-name {
  font-size: 16px;
  font-weight: 500;
  color: #202124;
  text-align: left;
  flex: 1 1;
}

.score-display {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.street-score {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 2px;
}

.street-count {
  font-size: 14px;
  color: #5f6368;
}

/* Color coding for scores */
.street-row:nth-child(1) .street-score { color: #1a73e8; }
.street-row:nth-child(2) .street-score { color: #34a853; }

/* Modal improvements */
.places-modal.compare .modal-content.compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  padding: 20px;
}

.modal-column {
  /* min-width: 100px;
  max-width: 100px; */
  background: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
}

.modal-column h4 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  color: #202124;
  font-size: 18px;
  text-align: center;
}

.places-scrollable {
  max-height: 350px;
  overflow-y: auto;
  padding-right: 10px;
}

.place-item {
  padding: 12px;
  border-bottom: 1px solid #eee;
  transition: background 0.2s;
}

.place-item:hover {
  background: white;
}

.place-name {
  font-weight: 500;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.place-rating {
  color: #f39c12;
  font-weight: 500;
  margin-bottom: 8px;
}

.map-link {
  display: inline-block;
  color: #1a73e8;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
}

.map-link:hover {
  text-decoration: underline;
}

/* Performance score in modal */
.modal-stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 15px 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stat-group {
  text-align: center;
  flex: 1 1;
}

.stat-label {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #202124;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .categories-grid.comparison {
    grid-template-columns: 1fr;
  }
  
  .places-modal.compare .modal-content.compare {
    grid-template-columns: 1fr;
  }
}

/* Remove the comparison bars */
.comparison-bars {
  display: none;
}

/* Center the comparison cards */
.amenity-categories.compare-mode .categories-grid {
  justify-content: center;
}

/* Adjust the header spacing */
.section-title {
  margin: 0 0 20px;
  padding-bottom: 10px;
}




/* Add to the end of the file */

/* Amenity Comparison Container */
.amenity-comparison-container {
  width: 100%;
  margin-top: 40px;
  padding: 0 15px;
}

.section-title.comparison-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid #1a73e8;
  position: relative;
}

/* .section-title.comparison-title::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  background: #1a73e8;
} */

/* Categories Grid */
.categories-grid.comparison {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Category Card */
.category-card.comparison {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #eaeaea;
  height: 100%;
}

.category-card.comparison:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.category-header.comparison {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.category-name.comparison {
  font-size: 20px;
  font-weight: 600;
  color: #202124;
  margin: 0;
}

/* Street Comparison */
.street-comparison {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.street-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background 0.2s;
}

.street-row:hover {
  background: #f1f8ff;
}

.street-name {
  font-size: 16px;
  font-weight: 500;
  color: #202124;
  text-align: left;
  flex: 1 1;
}

.score-display {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.street-score {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 2px;
}

.street-count {
  font-size: 14px;
  color: #5f6368;
}

/* Color coding for scores */
.street-row:nth-child(1) .street-score { color: #1a73e8; }
.street-row:nth-child(2) .street-score { color: #34a853; }

/* Responsive adjustments */
@media (max-width: 768px) {
  .categories-grid.comparison {
    grid-template-columns: 1fr;
  }
  
  .street-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .score-display {
    align-items: flex-start;
    width: 100%;
  }
}

/* Ensure full width layout */
.analysis-container {
  max-width: 100%;
  padding: 0;
}

.detailed-analysis,
.compare-area,
.comparison-results,
.amenity-categories,
.recommendations {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px;
}

.amenity-comparison-container {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 15px;
}
@media (max-width: 768px) {

  .places-modal{
    max-width: 1200px;
  }
  .places-modal .modal-content {
    padding: 24px;
    font-size: 1rem;       /* ≈16px base */
    line-height: 1.5;
  }
  .places-modal .modal-column {
    padding: 2px;
  }
}



/* 
.places-modal {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 1200px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
} */





































@media (max-width: 768px) {
  .places-scrollable {
    max-height: 80vh;   /* half the screen */
    overflow-y: auto;
  }
}
















































/* Detailed Analysis Compare Section - Mobile Horizontal Scroll Fix */
.detailed-analysis-compare {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 20px 0;
  max-width: 1200px;
  margin: 0 auto;
}

/* Single card - centered */
.detailed-analysis-compare:not(.two-cards) .street-detail-card {
  width: 100%;
  max-width: 600px;
}

/* Two cards layout */
.detailed-analysis-compare.two-cards {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow-x: auto;
  padding: 20px 15px;
  scrollbar-width: thin;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* Desktop layout - side by side */
@media (min-width: 768px) {
  .detailed-analysis-compare.two-cards {
    justify-content: center;
    flex-wrap: wrap;
    overflow-x: visible;
  }
  
  .detailed-analysis-compare.two-cards .street-detail-card {
    flex: 1 1;
    min-width: 0;
    max-width: calc(50% - 15px);
  }
}

/* Mobile layout - horizontal scroll */
@media (max-width: 767px) {
  .detailed-analysis-compare.two-cards .street-detail-card {
    min-width: 200px;
    margin-right: 10px;
    flex: 0 0 auto;
  }
  
  .detailed-analysis-compare.two-cards .street-detail-card:last-child {
    margin-right: 0;
  }
}

/* Scrollbar styling */
.detailed-analysis-compare.two-cards::-webkit-scrollbar {
  height: 6px;
}

.detailed-analysis-compare.two-cards::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.detailed-analysis-compare.two-cards::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

/* Consistent Category Cards */
.category-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: all 0.3s ease;
  border: 1px solid #eaeaea;
  cursor: pointer;
  overflow: hidden;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* Comparison specific styles */
.category-card.comparison {
  text-align: left;
}

/* Category grid */
.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
}





/* Add this to the end of AnalysisPage.css */
@media (max-width: 767px) {
  .detailed-analysis-compare.two-cards {
    padding-bottom: 25px; /* Space for scrollbar */
  }
  
  .detailed-analysis-compare.two-cards .street-detail-card {
    min-width: 1px; /* Slightly smaller cards */
    margin-right: 1px; /* Reduced gap */
    box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* More prominent shadow */
    border: 1px solid #e0e0e0; /* Added border */
  }
  
  .detailed-analysis-compare.two-cards::-webkit-scrollbar {
    height: 6px;
    background: #f1f1f1;
  }
  
  .detailed-analysis-compare.two-cards::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
}

/* Add this to the end of AnalysisPage.css */
/* @media (max-width: 768px) {
  .places-modal.compare .modal-content.compare {
    flex-direction: row;
    overflow-x: auto;
    -ms-overflow-style: none;  
    scrollbar-width: none; 
    padding: 15px 10px;
  }
  
  .places-modal.compare .modal-content.compare::-webkit-scrollbar {
    display: none; 
  }
  
  .modal-content.compare .modal-column {
    min-width: 85%;
    flex: 0 0 auto;
    margin-right: 15px;
  }
  
  .places-scrollable {
    max-height: 50vh;
  }
} */



/* Add to the end of the file */
@media (max-width: 767px) {
  .street-detail-card {
    min-width: 280px;
    padding: 15px;
    margin-right: 10px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    border: 1px solid #e0e0e0;
  }

  .detailed-analysis-compare.two-cards {
    padding-bottom: 15px;
  }
  
  .top3-item {
    font-size: 14px;
    gap: 6px;
  }
  
  .top3-label {
    flex: 0 0 100px;
  }
}





/* Compact two‑cards section on mobile with hidden scrollbar */
@media (max-width: 768px) {
  .detailed-analysis-compare {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding-bottom: 5px;
    -ms-overflow-style: none; /* IE/Edge */
    scrollbar-width: none;    /* Firefox */
  }
  .detailed-analysis-compare::-webkit-scrollbar {
    display: none;            /* Chrome/Safari */
  }
  .detailed-analysis-compare .street-detail-card {
    flex: 0 0 60%;
    min-width: 260px;
    /* optionally tighten padding */
    padding: 10px;
  }
}

/* Modal compare side‑by‑side on mobile with hidden scrollbar */
@media (max-width: 768px) {
  .places-modal.compare .modal-content.compare {
    display: flex;
    overflow-x: auto;
    gap: 2px;
    padding: 10px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 24px 12px;

  }
  .places-modal.compare .modal-content.compare::-webkit-scrollbar {
    display: none;
  }
  /* .places-modal.compare .modal-column {
    flex: 0 0 48%;
    min-width: 300px;
  } */

/* Two‑street compare: both columns get max‑width 50px */
  .places-modal.compare .modal-content.compare .modal-column:not(:single-child) {
    flex: 0 0 50px !important;
    min-width: 50px !important;
    max-width: 50px !important;
  }

  /* Single‑street modal: only child stretches to 300px */
  .places-modal.compare .modal-content.compare .modal-column:only-child {
    flex: 0 0 300px !important;
    min-width: 300px !important;
    max-width: 300px !important;
  }

    .places-modal {
    width: 95% !important;      /* up from 90% */
    max-width: 95% !important;
  }
}


@media (max-width: 768px) {
  /* When only one street‑detail‑card is present, make it take up nearly all the width */
  .detailed-analysis-compare .street-detail-card:only-child {
    flex: 0 0 95%;
    min-width: 95%;
    padding: 16px;      /* or your preferred padding */
    font-size: 1rem;    /* reset to normal size if you’d shrunk it elsewhere */
  }
}
/* Add these styles to the end of your CSS file */

/* Color classes for street names and scores */
.primary-street {
  color: #1a73e8;
}

.comparison-street {
  color: #34a853;
}

/* Apply to street names in detail cards */
.street-detail-card .location-info h2.primary-street {
  color: #1a73e8 !important;
}

.street-detail-card .location-info h2.comparison-street {
  color: #34a853 !important;
}

/* Apply to scores in detail cards */
.street-detail-card .score-value.primary-street {
  color: #1a73e8 !important;
}

.street-detail-card .score-value.comparison-street {
  color: #34a853 !important;
}

/* For amenity comparison cards */
.category-card.comparison .street-row .street-name.primary-street,
.category-card.comparison .street-row .street-score.primary-street {
  color: #1a73e8 !important;
}

.category-card.comparison .street-row .street-name.comparison-street,
.category-card.comparison .street-row .street-score.comparison-street {
  color: #34a853 !important;
}

/* For attribute comparison */
.score1.primary-street {
  color: #1a73e8 !important;
}

.score2.comparison-street {
  color: #34a853 !important;
}

/* Modal styling */
.modal-subtitle {
  margin-top: 5px;
  font-size: 14px;
  color: #5f6368;
}

.modal-vs {
  margin: 0 8px;
}

.modal-street-name {
  font-weight: 600;
}

.places-modal.compare .modal-column h4.primary-street {
  color: #1a73e8 !important;
  border-bottom: 2px solid #1a73e8;
}

.places-modal.compare .modal-column h4.comparison-street {
  color: #34a853 !important;
  border-bottom: 2px solid #34a853;
}








/* Updated Loader Styles - Make it centered properly */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh; /* Changed from 70vh to 100vh for full viewport centering */
    text-align: center;
    width: 100%;
    position: fixed; /* Changed to fixed for true center */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95); /* Slight white background */
    z-index: 9999;
}

.loading-spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #1a73e8;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

.loading-container p {
    font-size: 18px;
    color: #5f6368;
    margin: 0;
}

.places-modal {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    position: relative;
}

/* iPhone-specific modal adjustments */
@media (max-width: 768px) {
    .places-modal {
        width: 95% !important;
        max-width: 95% !important;
        max-height: 85vh !important; 
        margin: 10px auto !important;
        border-radius: 10px;
    }
    
    .places-modal.compare {
        max-height: 90vh !important;
    }
    
    .places-modal .modal-content.compare {
        display: flex;
        flex-direction: row;
        gap: 20px;
        padding: 15px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch; 
    }
    
    .places-modal .modal-column {
        flex: 1 1 auto !important;
        min-width: 100% !important;
        max-width: 100% !important;
        padding: 10px !important;
    }
    
    .places-modal .modal-header {
        padding: 15px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .places-modal .modal-header h3 {
        font-size: 18px;
        margin: 0;
    }
    
    .places-modal .modal-subtitle {
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        align-items: center;
    }
    
    .places-modal .modal-vs {
        font-size: 12px;
    }
    
    .places-modal .close-detail {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 36px;
        height: 36px;
        font-size: 28px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .places-modal .places-scrollable {
        max-height: 50vh;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 10px;
        border: 1px solid #eee;
        border-radius: 8px;
    }
    
    .places-modal .modal-stats {
        padding: 12px 15px;
        margin: 0 15px;
    }
    
    .places-modal .stat-value {
        font-size: 20px;
    }
    
    .places-modal .stat-label {
        font-size: 13px;
    }
}

/* iPhone SE and small screens */
@media (max-width: 375px) {
    .places-modal {
        max-height: 80vh !important;
        width: 98% !important;
    }
    
    .places-modal .modal-header {
        padding: 12px;
    }
    
    .places-modal .modal-header h3 {
        font-size: 16px;
    }
    
    .places-modal .modal-content.compare {
        padding: 10px;
        gap: 15px;
    }
    
    .places-modal .places-scrollable {
        max-height: 45vh;
        padding: 8px;
    }
    
    .place-item {
        padding: 8px 0;
        font-size: 14px;
    }
    
    .place-name {
        font-size: 15px;
    }
    
    .map-link {
        font-size: 13px;
        padding: 4px 0;
    }
}

/* Fix for iOS Safari address bar */
@supports (-webkit-touch-callout: none) {
    .loading-container {
        min-height: -webkit-fill-available;
    }
    
    .places-modal {
        max-height: -webkit-fill-available;
    }
    
    .modal-overlay {
        align-items: flex-end;
    }
    
    @media (max-width: 768px) {
        .modal-overlay {
            align-items: center;
            padding: 20px 0;
        }
        
        .places-modal {
            margin: auto 0;
        }
    }
}

/* Ensure modal overlay is properly positioned */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    overflow: hidden;
}

/* Better scroll handling for modal content */
.modal-content.compare {
    display: flex;
    flex: 1 1;
    overflow: hidden;
    padding: 20px;
    gap: 20px;
}

@media (max-width: 768px) {
    .modal-content.compare {
        flex-direction: column;
        overflow-y: auto;
        padding: 15px;
    }
    
    .modal-column {
        flex: 0 0 auto;
    }
    
    .modal-column h4 {
        font-size: 16px;
        padding: 10px 0;
        margin: 0 0 10px;
    }
}

/* Additional improvements for the loader */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-container .loading-spinner {
    animation: spin 1s linear infinite;
}

.scoring-note {
  font-size: 0.8rem;
  color: #666;
  margin-top: 8px;
  font-style: italic;
  text-align: center;
}


.ai-insights-section {
  margin-top: 40px;
  padding: 20px 0;
}

.ai-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ai-refresh-btn {
  padding: 8px 16px;
  border-radius: 6px;
  background: #3b82f6;
  color: #fff;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.ai-refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ai-error {
  color: red;
  margin-top: 8px;
}

.ai-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
  margin-bottom: 24px;
}

.ai-card-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

.ai-subtitle,
.ai-subsubtitle {
  margin-top: 12px;
  font-weight: 600;
}

.ai-text {
  margin-top: 6px;
  line-height: 1.5;
  color: #333;
}

.ai-divider {
  margin: 20px 0;
  border-bottom: 1px solid #e5e7eb;
}

.ai-bullet-list {
  margin-top: 10px;
  padding-left: 20px;
}

.ai-bullet-list li {
  margin-bottom: 6px;
}

.ai-compare-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}


/* AI Insights Section Styles */
.ai-insights-section {
  margin-top: 40px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 16px;
  position: relative;
}

.ai-header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.ai-header-left {
  flex: 1 1;
  min-width: 300px;
}

.ai-header-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.ai-subtitle-description {
  color: #666;
  font-size: 14px;
  margin-top: 4px;
  font-style: italic;
}

.ai-action-btn {
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: white;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  font-size: 14px;
}

.ai-action-btn:hover {
  background: #f0f0f0;
  transform: translateY(-1px);
}

.ai-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.regenerate-btn {
  background: #3b82f6;
  color: white;
  border: none;
}

.regenerate-btn:hover {
  background: #2563eb;
}

.info-btn {
  background: #f3f4f6;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* AI Content Area */
.ai-content-area {
  min-height: 200px;
}

/* AI Cards */
.ai-summary-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  border: 1px solid #e5e7eb;
}

.ai-summary-card.comparison-card {
  flex: 1 1;
  min-width: 0;
  margin: 0;
}

.ai-card-header {
  margin-bottom: 20px;
}

.ai-card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

/* AI Sections */
.ai-section {
  margin-bottom: 20px;
  background: #f9fafb;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e5e7eb;
}

.ai-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.ai-subtitle {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

/* One-liner section */
.ai-one-liner-section {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  border-left: 4px solid #0ea5e9;
}

.ai-one-liner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ai-quote-icon {
  font-size: 24px;
  color: #0ea5e9;
  font-weight: bold;
  line-height: 1;
}

.ai-one-liner-text {
  flex: 1 1;
  font-size: 16px;
  font-style: italic;
  color: #1e40af;
  line-height: 1.5;
  margin: 0;
}

/* AI Text */
.ai-text {
  font-size: 15px;
  line-height: 1.6;
  color: #4b5563;
  margin: 0;
}

/* Bullet Lists */
.ai-bullet-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ai-bullet-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  padding: 8px;
  background: white;
  border-radius: 6px;
  border-left: 3px solid #10b981;
}

.ai-bullet-icon {
  color: #10b981;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 2px;
}

.ai-bullet-text {
  flex: 1 1;
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
}

/* Comparison Grid */
.ai-comparison-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ai-comparison-row {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .ai-comparison-row {
    flex-direction: column;
  }
}

.ai-comparison-summary {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e5e7eb;
}

/* Verdict Box */
.ai-verdict-box {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #f59e0b;
}

.ai-verdict-text {
  font-size: 16px;
  font-weight: 500;
  color: #92400e;
  line-height: 1.6;
  margin: 0;
}

/* Loading States */
.ai-loading-state {
  text-align: center;
  padding: 40px 20px;
}

.ai-loading-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid #e5e7eb;
  border-radius: 50%;
  border-top-color: #3b82f6;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

.ai-loading-text {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.ai-loading-subtext {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* Empty State */
.ai-empty-state {
  text-align: center;
  padding: 40px 20px;
  background: white;
  border-radius: 12px;
  border: 2px dashed #d1d5db;
}

.ai-empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.ai-empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.ai-empty-description {
  font-size: 14px;
  color: #6b7280;
  max-width: 400px;
  margin: 0 auto 24px;
  line-height: 1.5;
}

.ai-generate-btn {
  padding: 12px 24px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.ai-generate-btn:hover {
  background: #2563eb;
}

/* Error States */
.ai-error-alert {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.error-icon {
  font-size: 20px;
  color: #dc2626;
  flex-shrink: 0;
  margin-top: 2px;
}

.error-content {
  flex: 1 1;
}

.error-title {
  font-size: 14px;
  font-weight: 600;
  color: #dc2626;
  margin: 0 0 4px;
}

.error-message {
  font-size: 13px;
  color: #7f1d1d;
  margin: 0 0 12px;
  line-height: 1.4;
}

.error-retry-btn {
  padding: 6px 12px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
}

.error-retry-btn:hover {
  background: #b91c1c;
}

/* Footer Note */
.ai-footer-note {
  margin-top: 20px;
  padding: 12px 16px;
  background: #f0f9ff;
  border-radius: 8px;
  border: 1px solid #bae6fd;
}

.ai-note-text {
  font-size: 13px;
  color: #0369a1;
  margin: 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.ai-note-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

/* Animation for AI content */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ai-summary-card,
.ai-comparison-summary,
.ai-empty-state {
  animation: fadeInUp 0.3s ease-out;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .ai-header-container {
    flex-direction: column;
  }
  
  .ai-header-right {
    width: 100%;
    justify-content: flex-start;
  }
  
  .ai-summary-card {
    padding: 16px;
  }
  
  .ai-comparison-row {
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AnalysisPage.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA,8BAA8B;EAC9B;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;;EAEA;IACE,qDAAqD;IACrD,mBAAmB;IACnB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,YAAY;EACd;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mCAAmC;IACnC,SAAS;IACT,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;;;IAGE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,KAAK,yBAAyB,EAAE;EAClC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,kBAAkB;MAClB,SAAS;IACX;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;EACF;;;EAGA,uBAAuB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;;;;;AAMA,gDAAgD;;AAEhD,oBAAoB;AACpB;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;;;;;;GAQG;;AAEH,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;GAEG;;AAEH,4BAA4B;AAC5B;EACE,aAAa;EACb,gBAAgB,EAAE,8BAA8B;EAChD,SAAO,EAAE,4BAA4B;AACvC;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,gBAAgB,EAAE,oCAAoC;EACtD,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;;;AAIA,uCAAuC;;AAEvC,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA,mCAAmC;AACnC;EACE,cAAc;EACd,iBAAiB;EACjB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,eAAe,UAAU,oCAAoC;EAC7D,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc,WAAW,+BAA+B;EACxD,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,IAAI,qBAAqB;;AAElD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB,KAAK,oBAAoB;EAC7C,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,OAAO,oBAAoB;EAC7C,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB,KAAK,oBAAoB;EAC7C,iCAAiC;EACjC,gBAAgB;AAClB;;;;AAIA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;;;;;;;;;GASG;;AAEH,mEAAmE;AACnE;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,gBAAgB,gBAAgB,0BAA0B;EAC1D,iCAAiC;EACjC,oBAAoB,YAAY,iCAAiC;AACnE;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,sDAAsD;AACxD;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;;;AAIA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB,MAAM,gDAAgD;EAC5E,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe,aAAa,gCAAgC;EAC5D,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO,qBAAqB,kCAAkC;EAC9D,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc,cAAc,iCAAiC;EAC7D,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,2BAA2B;EAC3B,wCAAwC;EACxC,sDAAsD;EACtD,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA,oBAAoB,mBAAmB,EAAE,GAAG,OAAO;AACnD,oBAAoB,mBAAmB,EAAE,GAAG,UAAU;AACtD,oBAAoB,mBAAmB,EAAE,GAAG,OAAO;;AAEnD;EACE,KAAK,kBAAkB,EAAE;AAC3B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,SAAO;EACP,WAAW;AACb;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,yEAAyE;AACzE;EACE,qCAAqC;AACvC;;AAEA,kDAAkD;AAClD;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;AAC/B;;;;;AAKA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;;;;;;;;;;;;;;;;AAiBA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,qDAAqD;EACrD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;;;AAKA,4BAA4B;;AAE5B,+BAA+B;;AAE/B,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;;AAEzD,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE;qBACmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;;;;AAKA,+BAA+B;;AAE/B,iCAAiC;AACjC;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;;AAEzD,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;;;;;EAKE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;;EAEE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe,QAAQ,eAAe;IACtC,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;;;;AAIA;;;;;;;;;;GAUG;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAsCH;EACE;IACE,gBAAgB,IAAI,oBAAoB;IACxC,gBAAgB;EAClB;AACF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAiDA,qEAAqE;AACrE;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;;;;;AAMA,4CAA4C;AAC5C;EACE;IACE,oBAAoB,EAAE,wBAAwB;EAChD;;EAEA;IACE,cAAc,EAAE,2BAA2B;IAC3C,iBAAiB,EAAE,gBAAgB;IACnC,qCAAqC,EAAE,0BAA0B;IACjE,yBAAyB,EAAE,iBAAiB;EAC9C;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;;;;;;;;;;;;;;;;;;;;;;GAsBG;;;;AAIH,+BAA+B;AAC/B;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;;;;;AAMA,8DAA8D;AAC9D;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,wBAAwB,EAAE,YAAY;IACtC,qBAAqB,KAAK,YAAY;EACxC;EACA;IACE,aAAa,aAAa,kBAAkB;EAC9C;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;;EAEpB;EACA;IACE,aAAa;EACf;EACA;;;KAGG;;AAEL,wDAAwD;EACtD;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA,uDAAuD;EACvD;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;IAEE;IACA,qBAAqB,OAAO,gBAAgB;IAC5C,yBAAyB;EAC3B;AACF;;;AAGA;EACE,sFAAsF;EACtF;IACE,aAAa;IACb,cAAc;IACd,aAAa,OAAO,8BAA8B;IAClD,eAAe,KAAK,sDAAsD;EAC5E;AACF;AACA,iDAAiD;;AAEjD,8CAA8C;AAC9C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;;;;;;;;AASA,sDAAsD;AACtD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB,EAAE,2DAA2D;IAC9E,kBAAkB;IAClB,WAAW;IACX,eAAe,EAAE,qCAAqC;IACtD,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC,EAAE,4BAA4B;IACnE,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA,sCAAsC;AACtC;IACI;QACI,qBAAqB;QACrB,yBAAyB;QACzB,2BAA2B;QAC3B,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,aAAa;QACb,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,aAAa;QACb,eAAe;QACf,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,eAAe;QACf,+BAA+B;QAC/B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iCAAiC;QACjC,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,gCAAgC;AAChC;IACI;QACI,2BAA2B;QAC3B,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI;YACI,mBAAmB;YACnB,eAAe;QACnB;;QAEA;YACI,cAAc;QAClB;IACJ;AACJ;;AAEA,gDAAgD;AAChD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA,2CAA2C;AAC3C;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;;AAGA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* Base styles */\n.analysis-container {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 15px;\n    color: #333;\n  }\n  \n  /* Header styles */\n  .analysis-header {\n    display: flex;\n    align-items: center;\n    padding: 15px 0;\n    border-bottom: 1px solid #eee;\n    margin-bottom: 20px;\n  }\n  \n  .back-button {\n    background: none;\n    border: none;\n    color: #1a73e8;\n    font-size: 16px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding: 8px 15px;\n    border-radius: 4px;\n    transition: background 0.2s;\n  }\n  \n  .back-button:hover {\n    background: #f1f8ff;\n  }\n  \n  .header-middle {\n    flex-grow: 1;\n    text-align: center;\n    color: #5f6368;\n    font-weight: 500;\n  }\n  \n  .header-title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #202124;\n    margin: 0;\n  }\n  \n  /* Detailed Analysis Section */\n  .detailed-analysis {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n    padding: 20px;\n    margin-bottom: 25px;\n  }\n  \n  .location-info h2 {\n    font-size: 22px;\n    margin: 0 0 5px;\n    color: #202124;\n    justify-content: center;\n  }\n  \n  .location-info p {\n    justify-content: center;\n    color: #5f6368;\n    margin: 0;\n  }\n  \n  .scores-container {\n    display: flex;\n    justify-content: center;\n    margin: 25px 0;\n  }\n  \n  .score-item {\n    text-align: center;\n  }\n  \n  .score-value {\n    font-size: 60px;\n    font-weight: 900;\n    color: #1a73e8;\n  }\n  \n  .score-label {\n    color: #5f6368;\n    font-size: 16px;\n  }\n  \n  .stats-container {\n    display: flex;\n    border-top: 1px solid #eee;\n    padding-top: 20px;\n  }\n  \n  .stat-item {\n    text-align: center;\n    flex: 1;\n  }\n  \n  .stat-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1a73e8;\n  }\n  \n  .stat-label {\n    color: #5f6368;\n    font-size: 14px;\n  }\n  \n  /* Section Titles */\n  .section-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #202124;\n    margin: 0 0 15px;\n    padding-bottom: 10px;\n    border-bottom: 2px solid #f1f3f4;\n  }\n  \n  /* Market Insights */\n  .market-insights {\n    margin-bottom: 25px;\n  }\n  \n  .premium-banner {\n    background: linear-gradient(135deg, #4285f4, #34a853);\n    border-radius: 10px;\n    padding: 20px;\n    color: white;\n  }\n  \n  .premium-content h3 {\n    font-size: 18px;\n    margin: 0 0 8px;\n  }\n  \n  .premium-content p {\n    margin: 0;\n    font-size: 14px;\n    opacity: 0.9;\n  }\n  \n  /* Compare Area */\n  .compare-area {\n    margin-bottom: 25px;\n  }\n  \n  .compare-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n    padding: 20px;\n  }\n  \n  .input-group {\n    margin-bottom: 15px;\n  }\n  \n  .compare-input {\n    width: 100%;\n    padding: 12px 15px;\n    border: 1px solid #dadce0;\n    border-radius: 8px;\n    font-size: 16px;\n    box-sizing: border-box;\n  }\n  \n  .compare-input:focus {\n    outline: none;\n    border-color: #1a73e8;\n    box-shadow: 0 0 0 2px rgba(26,115,232,0.2);\n  }\n  \n  .compare-button {\n    background: #1a73e8;\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    width: 100%;\n    margin-bottom: 15px;\n    transition: background 0.2s;\n  }\n  \n  .compare-button:hover {\n    background: #1669d9;\n  }\n  \n  .compare-description {\n    color: #5f6368;\n    font-size: 14px;\n    margin: 0;\n    line-height: 1.5;\n  }\n  \n  /* Comparison Results */\n  .comparison-results {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n    padding: 20px;\n    margin-bottom: 25px;\n  }\n  \n  .comparison-grid {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    gap: 20px;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .comparison-item {\n    padding: 15px;\n  }\n  \n  .comparison-item h3 {\n    margin: 0 0 10px;\n    font-size: 18px;\n  }\n  \n  .comparison-score-for-area1 {\n    font-size: 32px;\n    font-weight: 700;\n    color: #1a73e8;\n    margin: 10px 0;\n  }\n\n  .comparison-score-for-area2 {\n    font-size: 32px;\n    font-weight: 700;\n    color: #34a853;\n    margin: 10px 0;\n  }\n  \n  .close-comparison {\n    display: block;\n    margin: 20px auto 0;\n    background: none;\n    border: none;\n    color: #5f6368;\n    cursor: pointer;\n  }\n  \n  /* Categories */\n  .top-categories, .amenity-categories {\n    margin-bottom: 25px;\n  }\n  \n  .categories-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n    gap: 15px;\n  }\n  \n  .category-card {\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n    padding: 20px 15px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    border: 1px solid #eee;\n  }\n  \n  .category-card.active {\n    border-color: #1a73e8;\n    box-shadow: 0 2px 10px rgba(26,115,232,0.15);\n  }\n  \n  .category-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  }\n  \n  .category-icon {\n    font-size: 32px;\n    margin-bottom: 12px;\n  }\n  \n  .category-name {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 8px;\n    color: #202124;\n  }\n  \n  .category-count {\n    color: #5f6368;\n    font-size: 13px;\n  }\n  \n  /* Coverage Statistics */\n  .coverage-stats {\n    margin-bottom: 25px;\n  }\n  \n  .stats-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n    padding: 20px;\n  }\n  \n  .stats-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n  \n  .stats-grid .stat-item {\n    text-align: center;\n  }\n  \n  .stats-grid .stat-value {\n    font-size: 28px;\n  }\n  \n  /* Category Detail */\n  .category-detail {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n    padding: 20px;\n    margin-bottom: 25px;\n  }\n  \n  .category-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .category-title {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n  }\n  \n  .performance-rating {\n    text-align: center;\n  }\n  \n  .rating-value {\n    font-size: 32px;\n    font-weight: 700;\n    color: #1a73e8;\n  }\n  \n  .rating-label {\n    color: #5f6368;\n    font-size: 14px;\n  }\n  \n  .rating-score {\n    font-size: 16px;\n    font-weight: 500;\n    color: #5f6368;\n  }\n  \n  .category-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 15px;\n    margin-bottom: 20px;\n  }\n  \n  .stat-group {\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 15px;\n  }\n  \n  .stat-label {\n    color: #5f6368;\n    font-size: 14px;\n    margin-bottom: 5px;\n  }\n  \n  .stat-value {\n    font-size: 20px;\n    font-weight: 700;\n    color: #202124;\n  }\n  \n  .nearby-places {\n    margin-bottom: 20px;\n  }\n  \n  .nearby-places h3 {\n    font-size: 18px;\n    margin: 0 0 15px;\n    color: #202124;\n  }\n  \n  .place-item {\n    padding: 12px 0;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .place-name {\n    font-weight: 600;\n    margin-bottom: 5px;\n  }\n  \n  .place-rating {\n    color: #34a853;\n    font-weight: 500;\n    margin-bottom: 5px;\n  } \n  .map-link {\n    display: inline-block;\n    color: #1a73e8;\n    text-decoration: none;\n    font-size: 14px;\n    margin-top: 5px;\n  }\n  \n  .map-link:hover {\n    text-decoration: underline;\n  }\n  \n  .map-actions {\n    text-align: center;\n  }\n  \n  .view-map {\n    display: inline-block;\n    background: #1a73e8;\n    color: white;\n    padding: 10px 20px;\n    border-radius: 8px;\n    text-decoration: none;\n    font-weight: 500;\n    transition: background 0.2s;\n  }\n  \n  .view-map:hover {\n    background: #1669d9;\n  }\n  \n  /* Recommendations */\n  .recommendations {\n    margin-bottom: 40px;\n  }\n  \n  .subsection-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #202124;\n    margin: 0 0 15px;\n  }\n  \n  .recommendation-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n  }\n  \n  .recommendation-card {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n    padding: 20px;\n    transition: all 0.2s;\n  }\n  \n  .recommendation-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  }\n  \n  .card-icon {\n    font-size: 32px;\n    margin-bottom: 15px;\n  }\n  \n  .recommendation-card h4 {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0 0 10px;\n    color: #202124;\n  }\n  \n  .recommendation-card p {\n    color: #5f6368;\n    margin: 0;\n    line-height: 1.5;\n  }\n  \n  /* Loading, Error, No Data States */\n  .loading-container, \n  .error-container, \n  .no-data-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 70vh;\n    text-align: center;\n  }\n  \n  .loading-spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-left-color: #1a73e8;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    margin-bottom: 20px;\n  }\n  \n  @keyframes spin {\n    to { transform: rotate(360deg); }\n  }\n  \n  .error-icon, .no-data-icon {\n    font-size: 48px;\n    margin-bottom: 20px;\n  }\n  \n  .error-container h3, .no-data-container h3 {\n    font-size: 24px;\n    margin: 0 0 10px;\n  }\n  \n  .error-container p, .no-data-container p {\n    color: #5f6368;\n    margin: 0 0 20px;\n    max-width: 500px;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .scores-container {\n      flex-direction: column;\n      gap: 20px;\n    }\n    \n    .stats-container {\n      flex-direction: column;\n      gap: 15px;\n    }\n    \n    .comparison-grid {\n      grid-template-columns: 1fr;\n      gap: 30px;\n    }\n    \n    .recommendation-cards {\n      grid-template-columns: 1fr;\n    }\n    \n    .header-title {\n      font-size: 20px;\n    }\n    \n    .category-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 15px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .analysis-header {\n      flex-direction: column;\n      text-align: center;\n      gap: 10px;\n    }\n    \n    .back-button {\n      align-self: flex-start;\n    }\n    \n    .header-middle {\n      display: none;\n    }\n  }\n\n\n  /* Comparison Results */\n.attribute-comparison {\n  margin-top: 30px;\n}\n\n.attribute-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.attribute-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.attribute-name {\n  font-weight: 500;\n}\n\n.attribute-scores {\n  display: flex;\n  gap: 8px;\n}\n\n.score1 {\n  color: #1a73e8;\n  font-weight: 600;\n}\n\n.score2 {\n  color: #34a853;\n  font-weight: 600;\n}\n\n.score-divider {\n  color: #5f6368;\n}\n\n\n\n\n\n/* Add these new styles at the end of the file */\n\n/* Performance Bar */\n.performance-bar {\n  width: 100%;\n  height: 8px;\n  background-color: #f1f1f1;\n  border-radius: 4px;\n  margin: 10px 0;\n  overflow: hidden;\n}\n\n.performance-fill {\n  height: 100%;\n  transition: width 0.3s ease;\n}\n\n.performance-score {\n  font-size: 14px;\n  font-weight: 600;\n  color: #5f6368;\n  text-align: center;\n}\n\n/* View Locations Button */\n.view-locations {\n  background: #1a73e8;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 10px;\n  transition: background 0.2s;\n}\n\n.view-locations:hover {\n  background: #1669d9;\n}\n\n/* Places Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* .places-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n} */\n\n/* Modal Container */\n.places-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  /* Remove overflow: hidden */\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.modal-header h3 {\n  margin: 0;\n}\n\n.modal-header button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #5f6368;\n}\n\n/* .places-list {\n  padding: 20px;\n} */\n\n/* Scrollable Content Area */\n.places-list {\n  padding: 20px;\n  overflow-y: auto; /* Enable vertical scrolling */\n  flex: 1; /* Take up available space */\n}\n\n/* Places List Container */\n.places-scrollable {\n  max-height: 300px;\n  overflow-y: auto; /* Ensure scrolling for long lists */\n  border: 1px solid #eee;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n/* Scrollbar Styling */\n.places-scrollable::-webkit-scrollbar {\n  width: 8px;\n}\n\n.places-scrollable::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.places-scrollable::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.places-scrollable::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Score Bars in Comparison */\n.score-bar {\n  width: 100%;\n  height: 20px;\n  background-color: #f1f1f1;\n  border-radius: 10px;\n  margin: 5px 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.score-bar-fill {\n  height: 100%;\n  border-radius: 10px;\n}\n\n.score-value {\n  position: center;\n  right: 8px;\n  top: 30%;\n  transform: translateY(-50%);\n  font-size: 25px;\n  font-weight: 600;\n  color: black;\n  /* text-shadow: 0 0 2px rgba(0,0,0,0.5); */\n}\n\n/* Map Icon */\n.map-icon {\n  margin-left: 5px;\n}\n\n/* Attribute Comparison */\n.attribute-scores {\n  width: 60%;\n}\n\n.attribute-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.attribute-name {\n  font-weight: 500;\n  width: 40%;\n}\n\n\n\n/* Add to the end of AnalysisPage.css */\n\n/* Category Details Container */\n.category-details-container {\n  margin-top: 30px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-all-button {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.close-all-button:hover {\n  background: #d32f2f;\n}\n\n.category-detail {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n  padding: 20px;\n  margin-bottom: 25px;\n  position: relative;\n}\n\n.close-detail {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #5f6368;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.close-detail:hover {\n  background: #f1f1f1;\n}\n/* Inline Top‑3 styling — refined */\n.top-3-inline {\n  margin: 24px 0;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-color, #e0e0e0);\n  text-align: center;\n}\n\n.top-3-inline .subsection-title {\n  font-size: 1rem;         /* match other subsection headings */\n  font-weight: 500;\n  color: var(--text-primary, #333);\n  margin-bottom: 12px;\n}\n\n.top3-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 24px;          /* horizontal + vertical gaps */\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  text-align: justify;\n  justify-content: center;   /* center the group */\n\n}\n\n.top3-list li {\n  display: flex;\n  align-items: center;\n  font-size: 0.9375rem;    /* 15px equivalent */\n  color: var(--text-secondary, #555);\n  text-align: center;\n}\n\n.top3-icon {\n  font-size: 1.25rem;      /* 20px equivalent */\n  margin-right: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.top3-score {\n  font-weight: 600;\n  margin: 0 4px;\n  color: var(--accent, #1a73e8);\n}\n\n.top3-count {\n  font-size: 0.8125rem;    /* 13px equivalent */\n  color: var(--text-tertiary, #777);\n  margin-left: 4px;\n}\n\n\n\n/* Add to the end of AnalysisPage.css */\n.top-categories-comparison {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.top-categories-comparison h3 {\n  font-size: 18px;\n  color: #202124;\n  margin-bottom: 15px;\n}\n\n/* Mobile: stack top‑categories‑comparison into one column */\n/* @media (max-width: 768px) {\n  .top-categories-comparison .comparison-categories-grid {\n    grid-template-columns: 1fr !important;\n    gap: 10px;\n  }\n\n  .top-categories-comparison .area-top-categories {\n    padding: 10px;\n  }\n} */\n\n/* — Always two columns, horizontally scrollable on small screens */\n.top-categories-comparison .comparison-categories-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  overflow-x: auto;               /* allow sideways scroll */\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 1rem;           /* give a little breathing room */\n}\n\n/* optional: ensure each cell keeps a minimum width for readability */\n.top-categories-comparison .comparison-categories-grid > * {\n  min-width: 240px;\n}\n\n/* remove any leftover stacking rule */\n@media (max-width: 768px) {\n  /* nothing here — we want the same two‑column layout */\n}\n\n\n.comparison-categories-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.area-top-categories {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 15px;\n}\n\n.area-top-categories h4 {\n  margin: 0 0 15px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.category-comparison-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.category-comparison-item:last-child {\n  border-bottom: none;\n}\n\n.category-icon {\n  margin-right: 10px;\n  font-size: 24px;\n}\n\n.category-name {\n  flex-grow: 1;\n  font-weight: 500;\n}\n\n.category-score {\n  font-weight: 600;\n  color: #1a73e8;\n  font-size: 18px;\n}\n\n\n\n/* Top 3 inline with progress bars */\n.top3-list {\n  display: flex;\n  flex-direction: column;     /* one per row; switch to row+wrap if you like */\n  gap: 12px;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.top3-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.top3-icon {\n  font-size: 1.25rem;\n}\n\n.top3-label {\n  flex: 0 0 120px;            /* reserve space for the label */\n  font-weight: 500;\n  color: #333;\n}\n\n.top3-bar {\n  flex: 1;                    /* grows to fill remaining space */\n  height: 8px;\n  background: #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.top3-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.4s ease;\n}\n\n.top3-score {\n  flex: 0 0 50px;             /* fixed width for the “8.5/10” */\n  text-align: right;\n  font-weight: 600;\n  color: #1a73e8;\n}\n\n/* Animate the bar expanding from 0 → var(--fill) */\n.top3-fill {\n  width: 0;\n  animation: fillBar 0.8s ease-out forwards;\n}\n\n@keyframes fillBar {\n  to {\n    width: var(--fill);\n  }\n}\n\n/* Fade each item in and slide up slightly */\n.top3-item {\n  opacity: 0;\n  transform: translateY(10px);\n  animation: fadeUp 0.6s ease-out forwards;\n  /* stagger each by its index: set --i on the element */\n  animation-delay: calc(var(--i) * 0.15s);\n}\n\n@keyframes fadeUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.top3-fill.low    { background: #e74c3c; }  /* <5 */\n.top3-fill.medium { background: #f39c12; }  /* 5–7.9 */\n.top3-fill.high   { background: #27ae60; }  /* ≥8 */\n\n@keyframes fillBar {\n  to { width: var(--fill); }\n}\n\n/* wrap the little bar + labels */\n.category-stats {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n/* let the mini‑bar grow to fill available width */\n.category-stats .top3-bar {\n  flex: 1;\n  height: 6px;\n}\n\n/* reuse your existing .top3-fill animation & styling */\n.category-stats .top3-fill {\n  border-radius: 3px;\n}\n\n/* ensure the score text matches your Top‑3 style */\n.top3-score {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n/* count text, same as Top‑3 count */\n.top3-count {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n/* 3‑column layout for category cards */\n.amenity-categories.compare .categories-grid.compare {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 16px;\n}\n\n.category-card.compare {\n  display: contents; /* children occupy the grid cells */\n}\n\n.category-name-col {\n  grid-column: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.category-stats-col {\n  grid-column: auto;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Two‑column modal content */\n.places-modal.compare .modal-content.compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n/* ✅ If only ONE street exists, make modal content full width (desktop) */\n.places-modal.compare .modal-content.compare:has(.modal-column:only-child) {\n  grid-template-columns: 1fr !important;\n}\n\n/* Also ensure the single column stretches fully */\n.places-modal.compare .modal-content.compare .modal-column:only-child {\n  width: 100%;\n}\n\n.modal-column h4 {\n  margin-bottom: 8px;\n}\n/* Add to the end */\n.amenity-categories.compare-mode {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.compare-column {\n  background: #f8f9fa;\n  border-radius: 12px;\n  padding: 15px;\n}\n\n.compare-column h3 {\n  margin-top: 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n\n\n\n/* Add to end of file */\n.places-modal.compare .modal-content.compare {\n  display: flex;\n  gap: 20px;\n  padding: 15px;\n}\n\n.modal-column {\n  flex: 1;\n}\n\n.modal-column h4 {\n  margin-top: 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.places-scrollable {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #eee;\n  border-radius: 8px;\n}\n\n.place-item {\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.place-item:last-child {\n  border-bottom: none;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Comparison Card Styles */\n.comparison-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 20px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: pointer;\n  border: 1px solid #eaeaea;\n}\n\n.comparison-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n}\n\n.category-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.category-icon {\n  font-size: 28px;\n  margin-right: 12px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 50%;\n}\n\n.category-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #202124;\n  margin: 0;\n}\n\n.comparison-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.comparison-street {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.street-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #5f6368;\n  max-width: 60%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.score-badge {\n  display: flex;\n  align-items: baseline;\n}\n\n.score {\n  font-size: 18px;\n  font-weight: 700;\n  margin-right: 4px;\n}\n\n.comparison-street:nth-child(1) .score {\n  color: #1a73e8;\n}\n\n.comparison-street:nth-child(2) .score {\n  color: #34a853;\n}\n\n.count {\n  font-size: 13px;\n  color: #70757a;\n}\n\n.comparison-bars {\n  height: 6px;\n  background: #f1f3f4;\n  border-radius: 3px;\n  margin-top: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.bar {\n  position: absolute;\n  height: 100%;\n  border-radius: 3px;\n  top: 0;\n  transition: width 0.5s ease;\n}\n\n.bar1 {\n  background: #1a73e8;\n  left: 0;\n  z-index: 2;\n}\n\n.bar2 {\n  background: #34a853;\n  left: 0;\n  z-index: 1;\n  opacity: 0.8;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .comparison-street {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .street-name {\n    max-width: 100%;\n  }\n  \n  .score-badge {\n    align-self: flex-end;\n  }\n}\n\n/* Modal improvements */\n.places-modal.compare .modal-content.compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 25px;\n  padding: 20px;\n}\n\n.modal-column {\n  background: #f8f9fa;\n  border-radius: 10px;\n  padding: 15px;\n}\n\n.modal-column h4 {\n  margin-top: 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n  color: #202124;\n  font-size: 18px;\n}\n\n.places-scrollable {\n  max-height: 350px;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n/* Performance score in modal */\n.modal-stats {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.stat-group {\n  text-align: center;\n  flex: 1;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 5px;\n}\n\n.stat-value {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n\n\n\n/* ... existing styles ... */\n\n/* Add to the end of the file */\n\n/* Amenity Comparison Section */\n.amenity-categories.compare-mode {\n  margin-top: 30px;\n}\n\n.section-title.comparison-title {\n  font-size: 24px;\n  margin-bottom: 20px;\n  text-align: center;\n  border-bottom: 2px solid #1a73e8;\n  padding-bottom: 10px;\n}\n\n/* Comparison Cards Grid */\n.categories-grid.comparison {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  justify-content: center;\n}\n\n/* Comparison Card */\n.category-card.comparison {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  text-align: center;\n  transition: transform 0.3s ease;\n  border: 1px solid #eaeaea;\n}\n\n.category-card.comparison:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.category-header.comparison {\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.category-name.comparison {\n  font-size: 20px;\n  font-weight: 600;\n  color: #202124;\n  margin: 0;\n}\n\n/* Street Comparison Items */\n.street-comparison {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 15px;\n}\n\n.street-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.street-row:hover {\n  background: #f1f8ff;\n}\n\n.street-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #202124;\n  text-align: left;\n  flex: 1;\n}\n\n.score-display {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.street-score {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.street-count {\n  font-size: 14px;\n  color: #5f6368;\n}\n\n/* Color coding for scores */\n.street-row:nth-child(1) .street-score { color: #1a73e8; }\n.street-row:nth-child(2) .street-score { color: #34a853; }\n\n/* Modal improvements */\n.places-modal.compare .modal-content.compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 25px;\n  padding: 20px;\n}\n\n.modal-column {\n  /* min-width: 100px;\n  max-width: 100px; */\n  background: #f8f9fa;\n  border-radius: 10px;\n  padding: 15px;\n}\n\n.modal-column h4 {\n  margin-top: 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e0e0e0;\n  color: #202124;\n  font-size: 18px;\n  text-align: center;\n}\n\n.places-scrollable {\n  max-height: 350px;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n.place-item {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n  transition: background 0.2s;\n}\n\n.place-item:hover {\n  background: white;\n}\n\n.place-name {\n  font-weight: 500;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.place-rating {\n  color: #f39c12;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.map-link {\n  display: inline-block;\n  color: #1a73e8;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.map-link:hover {\n  text-decoration: underline;\n}\n\n/* Performance score in modal */\n.modal-stats {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 20px;\n  padding: 15px 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.stat-group {\n  text-align: center;\n  flex: 1;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 5px;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #202124;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .categories-grid.comparison {\n    grid-template-columns: 1fr;\n  }\n  \n  .places-modal.compare .modal-content.compare {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Remove the comparison bars */\n.comparison-bars {\n  display: none;\n}\n\n/* Center the comparison cards */\n.amenity-categories.compare-mode .categories-grid {\n  justify-content: center;\n}\n\n/* Adjust the header spacing */\n.section-title {\n  margin: 0 0 20px;\n  padding-bottom: 10px;\n}\n\n\n\n\n/* Add to the end of the file */\n\n/* Amenity Comparison Container */\n.amenity-comparison-container {\n  width: 100%;\n  margin-top: 40px;\n  padding: 0 15px;\n}\n\n.section-title.comparison-title {\n  text-align: center;\n  font-size: 24px;\n  margin-bottom: 25px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #1a73e8;\n  position: relative;\n}\n\n/* .section-title.comparison-title::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100px;\n  height: 3px;\n  background: #1a73e8;\n} */\n\n/* Categories Grid */\n.categories-grid.comparison {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 25px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Category Card */\n.category-card.comparison {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  text-align: center;\n  transition: all 0.3s ease;\n  border: 1px solid #eaeaea;\n  height: 100%;\n}\n\n.category-card.comparison:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n.category-header.comparison {\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.category-name.comparison {\n  font-size: 20px;\n  font-weight: 600;\n  color: #202124;\n  margin: 0;\n}\n\n/* Street Comparison */\n.street-comparison {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.street-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.street-row:hover {\n  background: #f1f8ff;\n}\n\n.street-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #202124;\n  text-align: left;\n  flex: 1;\n}\n\n.score-display {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.street-score {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.street-count {\n  font-size: 14px;\n  color: #5f6368;\n}\n\n/* Color coding for scores */\n.street-row:nth-child(1) .street-score { color: #1a73e8; }\n.street-row:nth-child(2) .street-score { color: #34a853; }\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .categories-grid.comparison {\n    grid-template-columns: 1fr;\n  }\n  \n  .street-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n  \n  .score-display {\n    align-items: flex-start;\n    width: 100%;\n  }\n}\n\n/* Ensure full width layout */\n.analysis-container {\n  max-width: 100%;\n  padding: 0;\n}\n\n.detailed-analysis,\n.compare-area,\n.comparison-results,\n.amenity-categories,\n.recommendations {\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 15px;\n}\n\n.amenity-comparison-container {\n  max-width: 1200px;\n  margin: 40px auto;\n  padding: 0 15px;\n}\n@media (max-width: 768px) {\n\n  .places-modal{\n    max-width: 1200px;\n  }\n  .places-modal .modal-content {\n    padding: 24px;\n    font-size: 1rem;       /* ≈16px base */\n    line-height: 1.5;\n  }\n  .places-modal .modal-column {\n    padding: 2px;\n  }\n}\n\n\n\n/* \n.places-modal {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 1200px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n} */\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media (max-width: 768px) {\n  .places-scrollable {\n    max-height: 80vh;   /* half the screen */\n    overflow-y: auto;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Detailed Analysis Compare Section - Mobile Horizontal Scroll Fix */\n.detailed-analysis-compare {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  padding: 20px 0;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Single card - centered */\n.detailed-analysis-compare:not(.two-cards) .street-detail-card {\n  width: 100%;\n  max-width: 600px;\n}\n\n/* Two cards layout */\n.detailed-analysis-compare.two-cards {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  overflow-x: auto;\n  padding: 20px 15px;\n  scrollbar-width: thin;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Desktop layout - side by side */\n@media (min-width: 768px) {\n  .detailed-analysis-compare.two-cards {\n    justify-content: center;\n    flex-wrap: wrap;\n    overflow-x: visible;\n  }\n  \n  .detailed-analysis-compare.two-cards .street-detail-card {\n    flex: 1;\n    min-width: 0;\n    max-width: calc(50% - 15px);\n  }\n}\n\n/* Mobile layout - horizontal scroll */\n@media (max-width: 767px) {\n  .detailed-analysis-compare.two-cards .street-detail-card {\n    min-width: 200px;\n    margin-right: 10px;\n    flex: 0 0 auto;\n  }\n  \n  .detailed-analysis-compare.two-cards .street-detail-card:last-child {\n    margin-right: 0;\n  }\n}\n\n/* Scrollbar styling */\n.detailed-analysis-compare.two-cards::-webkit-scrollbar {\n  height: 6px;\n}\n\n.detailed-analysis-compare.two-cards::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.detailed-analysis-compare.two-cards::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n/* Consistent Category Cards */\n.category-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  transition: all 0.3s ease;\n  border: 1px solid #eaeaea;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.category-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n}\n\n/* Comparison specific styles */\n.category-card.comparison {\n  text-align: left;\n}\n\n/* Category grid */\n.categories-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 0 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n\n\n\n\n/* Add this to the end of AnalysisPage.css */\n@media (max-width: 767px) {\n  .detailed-analysis-compare.two-cards {\n    padding-bottom: 25px; /* Space for scrollbar */\n  }\n  \n  .detailed-analysis-compare.two-cards .street-detail-card {\n    min-width: 1px; /* Slightly smaller cards */\n    margin-right: 1px; /* Reduced gap */\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1); /* More prominent shadow */\n    border: 1px solid #e0e0e0; /* Added border */\n  }\n  \n  .detailed-analysis-compare.two-cards::-webkit-scrollbar {\n    height: 6px;\n    background: #f1f1f1;\n  }\n  \n  .detailed-analysis-compare.two-cards::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n/* Add this to the end of AnalysisPage.css */\n/* @media (max-width: 768px) {\n  .places-modal.compare .modal-content.compare {\n    flex-direction: row;\n    overflow-x: auto;\n    -ms-overflow-style: none;  \n    scrollbar-width: none; \n    padding: 15px 10px;\n  }\n  \n  .places-modal.compare .modal-content.compare::-webkit-scrollbar {\n    display: none; \n  }\n  \n  .modal-content.compare .modal-column {\n    min-width: 85%;\n    flex: 0 0 auto;\n    margin-right: 15px;\n  }\n  \n  .places-scrollable {\n    max-height: 50vh;\n  }\n} */\n\n\n\n/* Add to the end of the file */\n@media (max-width: 767px) {\n  .street-detail-card {\n    min-width: 280px;\n    padding: 15px;\n    margin-right: 10px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n    border: 1px solid #e0e0e0;\n  }\n\n  .detailed-analysis-compare.two-cards {\n    padding-bottom: 15px;\n  }\n  \n  .top3-item {\n    font-size: 14px;\n    gap: 6px;\n  }\n  \n  .top3-label {\n    flex: 0 0 100px;\n  }\n}\n\n\n\n\n\n/* Compact two‑cards section on mobile with hidden scrollbar */\n@media (max-width: 768px) {\n  .detailed-analysis-compare {\n    display: flex;\n    overflow-x: auto;\n    gap: 10px;\n    padding-bottom: 5px;\n    -ms-overflow-style: none; /* IE/Edge */\n    scrollbar-width: none;    /* Firefox */\n  }\n  .detailed-analysis-compare::-webkit-scrollbar {\n    display: none;            /* Chrome/Safari */\n  }\n  .detailed-analysis-compare .street-detail-card {\n    flex: 0 0 60%;\n    min-width: 260px;\n    /* optionally tighten padding */\n    padding: 10px;\n  }\n}\n\n/* Modal compare side‑by‑side on mobile with hidden scrollbar */\n@media (max-width: 768px) {\n  .places-modal.compare .modal-content.compare {\n    display: flex;\n    overflow-x: auto;\n    gap: 2px;\n    padding: 10px;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    padding: 24px 12px;\n\n  }\n  .places-modal.compare .modal-content.compare::-webkit-scrollbar {\n    display: none;\n  }\n  /* .places-modal.compare .modal-column {\n    flex: 0 0 48%;\n    min-width: 300px;\n  } */\n\n/* Two‑street compare: both columns get max‑width 50px */\n  .places-modal.compare .modal-content.compare .modal-column:not(:single-child) {\n    flex: 0 0 50px !important;\n    min-width: 50px !important;\n    max-width: 50px !important;\n  }\n\n  /* Single‑street modal: only child stretches to 300px */\n  .places-modal.compare .modal-content.compare .modal-column:only-child {\n    flex: 0 0 300px !important;\n    min-width: 300px !important;\n    max-width: 300px !important;\n  }\n\n    .places-modal {\n    width: 95% !important;      /* up from 90% */\n    max-width: 95% !important;\n  }\n}\n\n\n@media (max-width: 768px) {\n  /* When only one street‑detail‑card is present, make it take up nearly all the width */\n  .detailed-analysis-compare .street-detail-card:only-child {\n    flex: 0 0 95%;\n    min-width: 95%;\n    padding: 16px;      /* or your preferred padding */\n    font-size: 1rem;    /* reset to normal size if you’d shrunk it elsewhere */\n  }\n}\n/* Add these styles to the end of your CSS file */\n\n/* Color classes for street names and scores */\n.primary-street {\n  color: #1a73e8;\n}\n\n.comparison-street {\n  color: #34a853;\n}\n\n/* Apply to street names in detail cards */\n.street-detail-card .location-info h2.primary-street {\n  color: #1a73e8 !important;\n}\n\n.street-detail-card .location-info h2.comparison-street {\n  color: #34a853 !important;\n}\n\n/* Apply to scores in detail cards */\n.street-detail-card .score-value.primary-street {\n  color: #1a73e8 !important;\n}\n\n.street-detail-card .score-value.comparison-street {\n  color: #34a853 !important;\n}\n\n/* For amenity comparison cards */\n.category-card.comparison .street-row .street-name.primary-street,\n.category-card.comparison .street-row .street-score.primary-street {\n  color: #1a73e8 !important;\n}\n\n.category-card.comparison .street-row .street-name.comparison-street,\n.category-card.comparison .street-row .street-score.comparison-street {\n  color: #34a853 !important;\n}\n\n/* For attribute comparison */\n.score1.primary-street {\n  color: #1a73e8 !important;\n}\n\n.score2.comparison-street {\n  color: #34a853 !important;\n}\n\n/* Modal styling */\n.modal-subtitle {\n  margin-top: 5px;\n  font-size: 14px;\n  color: #5f6368;\n}\n\n.modal-vs {\n  margin: 0 8px;\n}\n\n.modal-street-name {\n  font-weight: 600;\n}\n\n.places-modal.compare .modal-column h4.primary-street {\n  color: #1a73e8 !important;\n  border-bottom: 2px solid #1a73e8;\n}\n\n.places-modal.compare .modal-column h4.comparison-street {\n  color: #34a853 !important;\n  border-bottom: 2px solid #34a853;\n}\n\n\n\n\n\n\n\n\n/* Updated Loader Styles - Make it centered properly */\n.loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh; /* Changed from 70vh to 100vh for full viewport centering */\n    text-align: center;\n    width: 100%;\n    position: fixed; /* Changed to fixed for true center */\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.95); /* Slight white background */\n    z-index: 9999;\n}\n\n.loading-spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-left-color: #1a73e8;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    margin-bottom: 20px;\n}\n\n.loading-container p {\n    font-size: 18px;\n    color: #5f6368;\n    margin: 0;\n}\n\n.places-modal {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    position: relative;\n}\n\n/* iPhone-specific modal adjustments */\n@media (max-width: 768px) {\n    .places-modal {\n        width: 95% !important;\n        max-width: 95% !important;\n        max-height: 85vh !important; \n        margin: 10px auto !important;\n        border-radius: 10px;\n    }\n    \n    .places-modal.compare {\n        max-height: 90vh !important;\n    }\n    \n    .places-modal .modal-content.compare {\n        display: flex;\n        flex-direction: row;\n        gap: 20px;\n        padding: 15px;\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch; \n    }\n    \n    .places-modal .modal-column {\n        flex: 1 1 auto !important;\n        min-width: 100% !important;\n        max-width: 100% !important;\n        padding: 10px !important;\n    }\n    \n    .places-modal .modal-header {\n        padding: 15px;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .places-modal .modal-header h3 {\n        font-size: 18px;\n        margin: 0;\n    }\n    \n    .places-modal .modal-subtitle {\n        font-size: 14px;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 5px;\n        align-items: center;\n    }\n    \n    .places-modal .modal-vs {\n        font-size: 12px;\n    }\n    \n    .places-modal .close-detail {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        width: 36px;\n        height: 36px;\n        font-size: 28px;\n        background: rgba(0, 0, 0, 0.05);\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    \n    .places-modal .places-scrollable {\n        max-height: 50vh;\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch;\n        padding: 10px;\n        border: 1px solid #eee;\n        border-radius: 8px;\n    }\n    \n    .places-modal .modal-stats {\n        padding: 12px 15px;\n        margin: 0 15px;\n    }\n    \n    .places-modal .stat-value {\n        font-size: 20px;\n    }\n    \n    .places-modal .stat-label {\n        font-size: 13px;\n    }\n}\n\n/* iPhone SE and small screens */\n@media (max-width: 375px) {\n    .places-modal {\n        max-height: 80vh !important;\n        width: 98% !important;\n    }\n    \n    .places-modal .modal-header {\n        padding: 12px;\n    }\n    \n    .places-modal .modal-header h3 {\n        font-size: 16px;\n    }\n    \n    .places-modal .modal-content.compare {\n        padding: 10px;\n        gap: 15px;\n    }\n    \n    .places-modal .places-scrollable {\n        max-height: 45vh;\n        padding: 8px;\n    }\n    \n    .place-item {\n        padding: 8px 0;\n        font-size: 14px;\n    }\n    \n    .place-name {\n        font-size: 15px;\n    }\n    \n    .map-link {\n        font-size: 13px;\n        padding: 4px 0;\n    }\n}\n\n/* Fix for iOS Safari address bar */\n@supports (-webkit-touch-callout: none) {\n    .loading-container {\n        min-height: -webkit-fill-available;\n    }\n    \n    .places-modal {\n        max-height: -webkit-fill-available;\n    }\n    \n    .modal-overlay {\n        align-items: flex-end;\n    }\n    \n    @media (max-width: 768px) {\n        .modal-overlay {\n            align-items: center;\n            padding: 20px 0;\n        }\n        \n        .places-modal {\n            margin: auto 0;\n        }\n    }\n}\n\n/* Ensure modal overlay is properly positioned */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n    overflow: hidden;\n}\n\n/* Better scroll handling for modal content */\n.modal-content.compare {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n    padding: 20px;\n    gap: 20px;\n}\n\n@media (max-width: 768px) {\n    .modal-content.compare {\n        flex-direction: column;\n        overflow-y: auto;\n        padding: 15px;\n    }\n    \n    .modal-column {\n        flex: 0 0 auto;\n    }\n    \n    .modal-column h4 {\n        font-size: 16px;\n        padding: 10px 0;\n        margin: 0 0 10px;\n    }\n}\n\n/* Additional improvements for the loader */\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.loading-container .loading-spinner {\n    animation: spin 1s linear infinite;\n}\n\n.scoring-note {\n  font-size: 0.8rem;\n  color: #666;\n  margin-top: 8px;\n  font-style: italic;\n  text-align: center;\n}\n\n\n.ai-insights-section {\n  margin-top: 40px;\n  padding: 20px 0;\n}\n\n.ai-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ai-refresh-btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.ai-refresh-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ai-error {\n  color: red;\n  margin-top: 8px;\n}\n\n.ai-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.08);\n  margin-bottom: 24px;\n}\n\n.ai-card-title {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.ai-subtitle,\n.ai-subsubtitle {\n  margin-top: 12px;\n  font-weight: 600;\n}\n\n.ai-text {\n  margin-top: 6px;\n  line-height: 1.5;\n  color: #333;\n}\n\n.ai-divider {\n  margin: 20px 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.ai-bullet-list {\n  margin-top: 10px;\n  padding-left: 20px;\n}\n\n.ai-bullet-list li {\n  margin-bottom: 6px;\n}\n\n.ai-compare-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n\n/* AI Insights Section Styles */\n.ai-insights-section {\n  margin-top: 40px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 16px;\n  position: relative;\n}\n\n.ai-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.ai-header-left {\n  flex: 1;\n  min-width: 300px;\n}\n\n.ai-header-right {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.ai-subtitle-description {\n  color: #666;\n  font-size: 14px;\n  margin-top: 4px;\n  font-style: italic;\n}\n\n.ai-action-btn {\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  background: white;\n  color: #333;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n  font-size: 14px;\n}\n\n.ai-action-btn:hover {\n  background: #f0f0f0;\n  transform: translateY(-1px);\n}\n\n.ai-action-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.regenerate-btn {\n  background: #3b82f6;\n  color: white;\n  border: none;\n}\n\n.regenerate-btn:hover {\n  background: #2563eb;\n}\n\n.info-btn {\n  background: #f3f4f6;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* AI Content Area */\n.ai-content-area {\n  min-height: 200px;\n}\n\n/* AI Cards */\n.ai-summary-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  border: 1px solid #e5e7eb;\n}\n\n.ai-summary-card.comparison-card {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n}\n\n.ai-card-header {\n  margin-bottom: 20px;\n}\n\n.ai-card-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n/* AI Sections */\n.ai-section {\n  margin-bottom: 20px;\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n}\n\n.ai-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.ai-subtitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n\n/* One-liner section */\n.ai-one-liner-section {\n  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n  border-left: 4px solid #0ea5e9;\n}\n\n.ai-one-liner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.ai-quote-icon {\n  font-size: 24px;\n  color: #0ea5e9;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.ai-one-liner-text {\n  flex: 1;\n  font-size: 16px;\n  font-style: italic;\n  color: #1e40af;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* AI Text */\n.ai-text {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #4b5563;\n  margin: 0;\n}\n\n/* Bullet Lists */\n.ai-bullet-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.ai-bullet-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding: 8px;\n  background: white;\n  border-radius: 6px;\n  border-left: 3px solid #10b981;\n}\n\n.ai-bullet-icon {\n  color: #10b981;\n  font-weight: bold;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.ai-bullet-text {\n  flex: 1;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #374151;\n}\n\n/* Comparison Grid */\n.ai-comparison-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.ai-comparison-row {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 768px) {\n  .ai-comparison-row {\n    flex-direction: column;\n  }\n}\n\n.ai-comparison-summary {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 2px solid #e5e7eb;\n}\n\n/* Verdict Box */\n.ai-verdict-box {\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\n  border-radius: 8px;\n  padding: 20px;\n  border-left: 4px solid #f59e0b;\n}\n\n.ai-verdict-text {\n  font-size: 16px;\n  font-weight: 500;\n  color: #92400e;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Loading States */\n.ai-loading-state {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.ai-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid #e5e7eb;\n  border-radius: 50%;\n  border-top-color: #3b82f6;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n.ai-loading-text {\n  font-size: 16px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.ai-loading-subtext {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* Empty State */\n.ai-empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  background: white;\n  border-radius: 12px;\n  border: 2px dashed #d1d5db;\n}\n\n.ai-empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.ai-empty-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.ai-empty-description {\n  font-size: 14px;\n  color: #6b7280;\n  max-width: 400px;\n  margin: 0 auto 24px;\n  line-height: 1.5;\n}\n\n.ai-generate-btn {\n  padding: 12px 24px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.ai-generate-btn:hover {\n  background: #2563eb;\n}\n\n/* Error States */\n.ai-error-alert {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.error-icon {\n  font-size: 20px;\n  color: #dc2626;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.error-content {\n  flex: 1;\n}\n\n.error-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #dc2626;\n  margin: 0 0 4px;\n}\n\n.error-message {\n  font-size: 13px;\n  color: #7f1d1d;\n  margin: 0 0 12px;\n  line-height: 1.4;\n}\n\n.error-retry-btn {\n  padding: 6px 12px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.error-retry-btn:hover {\n  background: #b91c1c;\n}\n\n/* Footer Note */\n.ai-footer-note {\n  margin-top: 20px;\n  padding: 12px 16px;\n  background: #f0f9ff;\n  border-radius: 8px;\n  border: 1px solid #bae6fd;\n}\n\n.ai-note-text {\n  font-size: 13px;\n  color: #0369a1;\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.ai-note-icon {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Animation for AI content */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ai-summary-card,\n.ai-comparison-summary,\n.ai-empty-state {\n  animation: fadeInUp 0.3s ease-out;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .ai-header-container {\n    flex-direction: column;\n  }\n  \n  .ai-header-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .ai-summary-card {\n    padding: 16px;\n  }\n  \n  .ai-comparison-row {\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
